<div class="table-responsive" [class.overflow-hidden]="stripeAccountsService.emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover footable">
        <thead>
            <tr [ngClass]="{'noSort': stripeAccountsService.data.data.length < 2}">
                <th (click)="orderBy('id', $event)">
                    ID <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('createdAt', $event)" class="footable-sorted">
                    Pay Out Date <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('createdBy', $event)">
                    Created By <span class="footable-sort-indicator"></span>
                </th>
                <th  class="text-right" (click)="orderBy('amount', $event)">
                    Amount <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('status', $event)">
                    Status <span class="footable-sort-indicator"></span>
                </th>
                <th>Actions</th>
            </tr>
        </thead>
        <tbody>
            <ng-template ngFor let-item [ngForOf]="stripeAccountsService.data.data" let-index="index">
                <tr>
                    <td>{{item.id}}</td>
                    <td>{{item.createdAt | mccDate:true:true}}</td>
                    <td>{{item.createdBy?.fullName}}</td>
                    <td class="text-right">{{item.amount | currency}}</td>
                    <td class="text-capitalize">
                        <span class="label label-{{item.status}}">{{item.status}}</span>
                    </td>
                    <td class="td-action-btn">
                        <div class="input-group-btn btn-in-table input-group">
                            <a href="{{item?.linkToReport?.xlsx}}" target="_blank" class="btn btn-white btn-xs">
                                Get Report
                            </a>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <tr *ngFor="let item of stripeAccountsService.emptyRowService.emptyRow" style="cursor: default;">
                <td></td><td></td><td></td><td></td><td></td><td></td>
            </tr>
        </tbody>
    </table>

    <empty-result-message [isEmpty]="!stripeAccountsService.data.total"
                          [isServiceUnavailable]="stripeAccountsService.showServiceUnavailable"
                          [isLoading]="stripeAccountsService.spinnerShow">
        You have no {{stripeAccountsService.selectedTab}} listed on the system<br>
    </empty-result-message>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/stripe-accounts/stripe-payouts-list/stripe-payouts-list.component.html